import { configProps, LocationEntry } from "../../types";
import { getCountryName } from "../../helpers/countryNames.ts";

export const locationsConfig: configProps<"locations"> = {
  view: "locations",
  title: "Lokalizacje",
  columns: [
    {
      id: 1,
      field: "address",
      header: "Adres",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "text",
      required: true,
      sortable: true,
    },
    {
      id: 2,
      field: "country",
      header: "Kraj",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "text",
      required: true,
      sortable: true,
      body: (rowData: LocationEntry) => getCountryName(rowData.country),
    },
    {
      id: 3,
      field: "city",
      header: "Miasto",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "text",
      required: true,
      sortable: true,
    },
    {
      id: 4,
      field: "latitude",
      header: "Szerokość",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "number",
      required: true,
    },
    {
      id: 5,
      field: "longitude",
      header: "Długość",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "number",
      required: true,
    },
    {
      id: 6,
      field: "contactPersonName",
      header: "Osoba kontaktowa",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "text",
    },
    {
      id: 7,
      field: "contactPersonPhone",
      header: "Telefon kontaktowy",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "text",
    },
  ],
};
